import config from '@app/config'

import { createLogger } from './loggerCreator'

type MethodName = 'hit' | 'reachGoal' | 'userParams' | 'setUserID'

const log = createLogger('ym', 'yellow')

/**
 * Official tag.js bootstrap queue: calls made before the script loads are
 * pushed into `window.ym.a` and replayed by tag.js once it initializes.
 */
function ensureStub(): YandexMetrikaQueue {
  if (!window.ym) {
    const stub: YandexMetrikaQueue = function () {
      // eslint-disable-next-line prefer-rest-params
      ;(stub.a = stub.a || []).push(arguments)
    }
    stub.l = Date.now()
    window.ym = stub
  }
  return window.ym
}

function ym(methodName: MethodName, ...args: any) {
  if (BUILD_MODE === 'dev') {
    log.log(methodName, ...args)
  } else if (IS_BROWSER && config.metrikaCounterId) {
    ensureStub()(config.metrikaCounterId, methodName, ...args)
  }
}

export default ym
